var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M94.4628 100C97.5207 100 100 97.5207 100 94.4628V5.53719C100 2.47934 97.5207 0 94.4628 0H5.53719C2.47934 0 0 2.47934 0 5.53719V94.5041C0 97.5207 2.47934 100 5.53719 100H94.4628Z","fill":"#485A96","key":0}),React.createElement("path",{"d":"M69.0083 100V61.281H82.0248L83.9669 46.1983H69.0083V36.5289C69.0083 32.1488 70.2066 29.1736 76.4876 29.1736H84.4628V15.7025C83.0992 15.5372 78.3471 15.124 72.8099 15.124C61.281 15.124 53.3884 22.1488 53.3884 35.0826V46.1983H40.3719V61.281H53.3884V100H69.0083Z","fill":"white","key":1})]);
}

Facebook.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
